"use client"
import { useTheme } from "@mui/material/styles"
import type { FC } from "react"
import { useTranslation } from "react-i18next"

import styles from "./PostSidebarPostWidget.module.scss"

import { PostWidget } from "@/components/common/post-widget"
import type { PostWidgetItem } from "@/components/common/post-widget"
import { create } from "@/helpers/bem"

const bem = create(styles, "PostSidebarPostWidget")

export type PostSidebarPostWidgetProps = {
  data: PostWidgetItem[]
}

export const PostSidebarPostWidget: FC<PostSidebarPostWidgetProps> = ({
  data,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  return (
    <PostWidget
      background={3}
      items={data}
      listClassName={bem("list", {
        [theme.palette.mode]: true,
      })}
      title={{
        content: t("pages.views.postSidebar.teasers.mostPopular"),
      }}
    />
  )
}
